import { useEffect, useRef, useState } from "react";
import { StepContainer } from "../components/StepContainer";
import { FunnelFields } from "../components/fields/FunnelFields";
import { useOnboardingNote } from "../hooks/useOnboardingNote";
import { useUpdateBusinessContext } from "../hooks/useUpdateBusinessContext";
import { useBusinessContext } from "@/hooks/useBusinessContext";
import { STEPS, findStepIndexBySlug } from "../config/steps";

export interface FunnelStepProps {
  onValidityChange: (valid: boolean) => void;
  onAttemptContinue: (continueFn: () => Promise<boolean>) => void;
  onMissingChange?: (labels: string[]) => void;
}

export function FunnelStep({
  onValidityChange,
  onAttemptContinue,
  onMissingChange,
}: FunnelStepProps) {
  const step = STEPS[findStepIndexBySlug("funil")];
  const { mutate, mutateDebounced } = useUpdateBusinessContext();
  const { query } = useBusinessContext();
  const { notes, setNotes } = useOnboardingNote();

  const [sources, setSources] = useState<string[]>([]);
  const sourcesRef = useRef(sources);
  sourcesRef.current = sources;

  useEffect(() => {
    const row = query.data;
    if (!row) return;
    const rowSources = (row as Record<string, unknown>).funnel_sources as string[] | null;
    if (rowSources?.length && sources.length === 0) setSources(rowSources);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.data]);

  useEffect(() => {
    onValidityChange(true);
    if (onMissingChange) onMissingChange([]);
  }, [onValidityChange, onMissingChange]);

  useEffect(() => {
    onAttemptContinue(async () => {
      await mutate({ funnel_sources: sourcesRef.current } as never);
      return true;
    });
  }, [mutate, onAttemptContinue]);

  const handleSourcesChange = (next: string[]) => {
    setSources(next);
    mutateDebounced({ funnel_sources: next } as never);
  };

  return (
    <StepContainer
      icon={step.icon}
      headline={step.headline}
      sub={step.sub}
      importanceNote="Ajuda a IA a gerar roteiros e mensagens segmentados pelo estágio do funil do seu cliente."
    >
      <FunnelFields
        sources={sources}
        onSourcesChange={handleSourcesChange}
        notes={notes}
        onNotesChange={setNotes}
      />
    </StepContainer>
  );
}
